var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RecycleScroller',_vm._g(_vm._b({ref:"scroller",attrs:{"items":_vm.itemsWithSize,"min-item-size":_vm.minItemSize,"direction":_vm.direction,"key-field":"id","list-tag":_vm.listTag,"item-tag":_vm.itemTag},on:{"resize":_vm.onScrollerResize,"visible":_vm.onScrollerVisible},scopedSlots:_vm._u([{key:"default",fn:function({ item: itemWithSize, index, active }){return [_vm._t("default",null,null,{
        item: itemWithSize.item,
        index,
        active
        // itemWithSize
      })]}}],null,true)},'RecycleScroller',_vm.$attrs,false),_vm.listeners),[_c('template',{slot:"before"},[_vm._t("before")],2),_c('template',{slot:"after"},[_vm._t("after")],2),_c('template',{slot:"empty"},[_vm._t("empty")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }